import { ReactNode, useEffect } from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import keycloak from "../../auth/keycloak";
import { CommonSpin } from "../../pages/base/components/spin/CommonSpin";

type Props = {
  children: ReactNode;
  roles?: string[];
};

export default function ProtectedRoute({ children, roles }: Props) {
  const { isAuthenticated, isLoading, hasRequiredRole } = useAuth(roles);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      keycloak.login();
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) return <CommonSpin fullscreen />;

  if (!isAuthenticated) return null; 

  if (roles && !hasRequiredRole)
    return <Navigate to="/unauthorized" replace />;

  return <>{children}</>;
}
